import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import Attachments from 'src/components/Attachments';
import DateInput from 'src/components/Pickers/DateInput';
import EntityPicker from "../Pickers/Picker";
import Expense from 'src/store/models/Expense';
import Project from 'src/store/models/Project';
import ExpenseCategory from 'src/store/models/ExpenseCategory';
import BillableStatusPicker from 'src/components/Pickers/BillableStatus';
import User from 'src/store/models/User';
import { dialog } from 'src/boot/mixins.js';
import { colorUtils } from 'src/mixins/colors-utils';
import { cloneDeep } from 'lodash';
import moment from 'moment';
export default {
  mixins: [dialog, colorUtils],
  props: {
    expense: {
      type: Object,
      default: null
    },
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      isDirty: false,
      errors: {
        amount: false,
        description: false,
        expense_category_id: false,
        project_id: false
      },
      billable: this.expense && (this.expense.billable_status === 'unbilled' || this.expense.billable_status === 'billed') ? 1 : 0,
      localExpense: {
        description: null,
        expense_category_id: null,
        project_id: null,
        user_id: User.me().user_id,
        billable_status: 'non-billable',
        date: moment().format('YYYY-MM-DD'),
        amount: null,
        attachments: []
      }
    };
  },
  watch: {
    localExpense: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val.expense_category_id === -1) {
          this.localExpense.expense_category_id = null;
        }

        if (val.project_id === -1) {
          this.localExpense.project_id = null;
        }

        if (!this.isDirty && oldVal && this.expense) {
          this.isDirty = true;
        }
      }
    },
    selectedProject: function selectedProject(val) {
      if (val && !val.is_billable) {
        this.localExpense.billable_status = 'non-billable';
      }
    }
  },
  components: {
    TeDialog: TeDialog,
    DateInput: DateInput,
    EntityPicker: EntityPicker,
    Attachments: Attachments,
    BillableStatusPicker: BillableStatusPicker
  },
  computed: {
    title: function title() {
      if (this.expense) {
        if (this.readonly) {
          return this.$t('components.expenseDialog.expense_details');
        }

        return this.$t('components.expenseDialog.edit_expense');
      }

      return this.$t('components.expenseDialog.create_new_expense');
    },
    category: function category() {
      return ExpenseCategory.query().where('expense_category_id', this.localExpense.expense_category_id).first();
    },
    calculatedAmount: function calculatedAmount() {
      var amount = this.localExpense.amount;

      if (this.category && this.category.uses_unit_price) {
        amount = this.localExpense.amount * this.unitPrice;
      }

      return amount.toFixed(2);
    },
    unitPrice: function unitPrice() {
      if (this.expense && this.expense.unit_price && this.expense.expense_category_id === this.category.expense_category_id) {
        return this.expense.unit_price;
      } else if (this.category) {
        return this.category.unit_price;
      }

      return 1;
    },
    unitName: function unitName() {
      if (this.expense && this.expense.unit_name && this.expense.expense_category_id === this.category.expense_category_id) {
        return this.expense.unit_name;
      } else if (this.category) {
        return this.category.unit_name;
      }

      return '';
    },
    usesUnitPrice: function usesUnitPrice() {
      return this.category && this.category.uses_unit_price && this.category.unit_name;
    },
    selectedProject: function selectedProject() {
      return Project.query().where('project_id', this.localExpense.project_id).first();
    },
    billableOptions: function billableOptions() {
      if (!this.selectedProject || this.selectedProject && this.selectedProject.is_billable) {
        return [{
          value: 'unbilled',
          label: this.$t('general.unbilled')
        }, {
          value: 'billed',
          label: this.$t('general.billed')
        }, {
          value: 'non-billable',
          label: this.$t('general.non_billable')
        }];
      }

      return [{
        value: 'non-billable',
        label: this.$t('general.not_billable')
      }];
    },
    hiddenBillableStatus: function hiddenBillableStatus() {
      var _this$selectedProject, _this$selectedProject2;

      // eslint-disable-next-line camelcase
      return ((_this$selectedProject = this.selectedProject) === null || _this$selectedProject === void 0 ? void 0 : _this$selectedProject.billing_type) === 'fixed_fee' || ((_this$selectedProject2 = this.selectedProject) === null || _this$selectedProject2 === void 0 ? void 0 : _this$selectedProject2.billing_type) === 'not_billable';
    },
    projectRequired: function projectRequired() {
      var projectRequired = this.me.account.settings.required_fields && this.me.account.settings.required_fields.includes('expense_project');
      return projectRequired && !this.selectedProject;
    }
  },
  methods: {
    initData: function initData() {
      var _this = this;

      if (this.expense) {
        this.localExpense = cloneDeep(this.expense);
      }

      this.$nextTick(function () {
        _this.isDirty = false;
      });
    },
    validate: function validate() {
      var validData = true;

      if (!this.localExpense.amount) {
        this.errors.amount = true;
      }

      if (!this.localExpense.description) {
        this.errors.description = true;
      }

      if (!this.localExpense.expense_category_id) {
        this.errors.expense_category_id = true;
      }

      if (this.projectRequired && !this.localExpense.project_id) {
        this.errors.project_id = true;
      }

      Object.values(this.errors).forEach(function (err) {
        if (err === true) {
          validData = false;
        }
      });
      return validData;
    },
    getCategoryOptions: function getCategoryOptions() {
      var options = [];

      if (this.me.is_admin) {
        options.push('new-option');
      }

      return options;
    },
    deleteExpense: function deleteExpense() {
      var _this2 = this;

      this.openDialog('UserConfirmationDialog', {
        title: this.$t('general.expense_deletion'),
        icon: 'fal:wallet',
        type: 'danger',
        message: this.$t('components.expenseDialog.you_are_deleting_expense'),
        html: true,
        confirmButtonText: this.$t('general.delete'),
        confirmButtonColor: 'negative',
        confirmTimeout: 2000,
        onConfirm: function onConfirm() {
          _this2.showLoading();

          return Expense.api().delete('/expenses/' + _this2.expense.expense_id).then(function (response) {
            _this2.$root.$emit('refresh-expenses');

            _this2.$q.notify({
              message: _this2.$t('components.expenseDialog.deleted_expense'),
              type: 'positive'
            });

            _this2.onOKClick();
          });
        }
      });
    },
    saveExpense: function saveExpense() {
      var _this3 = this;

      if (!this.validate()) {
        return;
      }

      this.loading = true;
      this.showLoading();
      var expenseData = cloneDeep(this.localExpense);
      delete expenseData.attachments;

      if (!this.localExpense.expense_id) {
        Expense.api().store(expenseData).then(function (result) {
          _this3.localExpense.expense_id = result.response.data.expense_id;

          if (_this3.localExpense.attachments.length > 0) {
            _this3.saveAttachments();
          } else {
            _this3.$root.$emit('refresh-expenses');

            _this3.onOKClick();

            _this3.hideLoading();

            _this3.loading = false;
          }
        }).catch(function () {
          _this3.hideLoading();

          _this3.loading = false;
        });
      } else {
        Expense.api().update(this.localExpense.expense_id, expenseData).then(function () {
          if (_this3.expense.attachments !== _this3.localExpense.attachments) {
            _this3.saveAttachments();
          } else {
            _this3.onOKClick();

            _this3.hideLoading();

            _this3.loading = false;
          }
        }).catch(function () {
          _this3.hideLoading();

          _this3.loading = false;
        });
      }
    },
    deleteLocalAttachment: function deleteLocalAttachment(attachment) {
      this.showLoading();

      if (!attachment.attachment_id) {
        this.localExpense.attachments.splice(attachment.index, 1);
        this.expense.attachments = this.localExpense.attachments;
        this.hideLoading();
        return;
      }

      this.localExpense.attachments = this.localExpense.attachments.filter(function (attach) {
        return attach.attachment_id !== attachment.attachment_id;
      });
      this.expense.attachments = this.localExpense.attachments;
      this.hideLoading();
    },
    saveAttachments: function saveAttachments() {
      var _this4 = this;

      this.showLoading();
      var files = new FormData();
      var filteredAttachments = this.localExpense.attachments.filter(function (attachment) {
        return !attachment.attachment_id;
      });
      filteredAttachments.forEach(function (file) {
        files.append('files[]', file);
      });
      return this.$axios.post('/attachments', files, {
        headers: {
          'Content-Type': 'multipart/fom-data'
        },
        params: {
          attachable_id: this.localExpense.expense_id,
          attachable_type: 'expense'
        }
      }).then(function (response) {
        _this4.$root.$emit('refresh-expenses');

        if (!_this4.expense) {
          _this4.$q.notify({
            message: _this4.$t('components.expenseDialog.expense_created_successfuly'),
            type: 'positive'
          });
        } else {
          _this4.$q.notify({
            message: _this4.$t('components.expenseDialog.updated_last_expenses'),
            type: 'positive'
          });
        }

        _this4.onOKClick();

        _this4.hideLoading();

        _this4.loading = false;
      }).catch(function () {
        _this4.hideLoading();

        _this4.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.initData();
  }
};